export enum TradingMode {
  Classic = 'classic',
  // Express = 'express',
  Agent = 'agent',
}

export interface BaseResponse<T = unknown> {
  code?: number; // if not 200, it means error
  errMsg?: string; // if code not 200,this is error message
  data?: T; // if code is 200,this is data
  uuid?: string; // every request has a uuid
  t?: number; // server time
  msg?: string;
}

// JWT Token Response
export interface JwtTokenRespDto {
  token?: string;
  refreshToken?: string;
  subAccount?: string;
}

// Login Request
export interface UserLoginReqDto {
  chainId: number;
  userAddr: string; // User's wallet address
  signature: string; // Signature for the request
  nonce: number; // Nonce for the request to prevent replay attacks
  timestamp: number; // Timestamp of the request
}

export interface EnableAgentReqDto {
  chainId: number;
  action: 0 | 1;
  deadline: number;
  signature: string;
}

export interface EnableAgentRespDto {
  taskId: string;
}

// Removed unused type: SendGelatoTransactionReqDto

export interface SendGelatoTransactionRespDto {
  taskId: string;
}

// Login Request
export interface TxLoginRequest {
  chainId: number;
  userAddr: string; // User's wallet address
  signature: string; // Signature for the request
  nonce: number; // Nonce for the request to prevent replay attacks
}

// JWT Token Response
export interface TxLoginResponse {
  token: string;
  proxyAddr: string;
}

export interface TxSubmitRequest {
  chainID: number;
  calldata: string;
  gasLimit?: string;
  gasPrice?: string;
  to: string;
  value?: string;
  userAddr: string;
}

export interface TxSubmitResponse {
  txHash: `0x${string}`;
}
